<template>
  <div :class="grid">
    <div
      v-for="i in limit"
      :key="i"
      class="animate-pulse bg-white h-100 border border-gray-100"
    >
      <div class="bg-gray-100 w-full h-82"></div>
      <div class="flex items-center justify-between p-2.5">
        <div class="flex items-center space-x-2 w-full">
          <div class="size-12 min-w-12 rounded-full bg-gray-100"></div>
          <div class="w-full space-y-1">
            <div class="sm:h-4 h-3 w-1/2 bg-gray-100"></div>
            <div class="sm:h-4 h-3 w-1/3 bg-gray-100"></div>
          </div>
        </div>
        <Icon name="ph:heart-fill" size="28" class="text-gray-300" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ limit: number; grid?: string }>(), {
  grid: "grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 grid-cols-1 sm:gap-2.5 gap-2",
});
</script>
